<script lang="ts">
  /** Removable enamel plates captured between the lips of a metal channel. */
  let {
    state,
    compact = false,
  }: { state: 'open' | 'closed' | 'groomed'; compact?: boolean } = $props()
</script>

<span class="status-slot" class:compact aria-hidden="true">
  {#key state}<span class="insert {state}">{state}</span>{/key}
</span>

<style>
  .status-slot {
    display: inline-flex;
    flex: none;
    position: relative;
    overflow: hidden;
    padding: 3px 4px;
    background: #8a999e;
    border-inline: 2px solid #b8c2c4;
    border-radius: 1px;
    box-shadow: 0 1px 0 #ffffff80, inset 0 2px 3px #26363d66;
    vertical-align: middle;
  }
  .status-slot::before,
  .status-slot::after {
    content: '';
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(#e6ecec, #9aabae 65%, #677b81);
    box-shadow: 0 1px 1px #263e4855;
  }
  .status-slot::before { top: 0; }
  .status-slot::after { bottom: 0; }
  .insert {
    display: block;
    width: 100%;
    min-width: 51px;
    padding: 2px 7px;
    border: 1px solid #ffffff;
    border-radius: 1px;
    color: #153e32;
    font: 750 11px/14px var(--font);
    letter-spacing: .045em;
    text-align: center;
    text-transform: uppercase;
    box-shadow: inset 0 1px 0 #ffffff, 1px 0 2px #26363d55;
  }
  .open { background: #ffffff; color: #126346; }
  .closed { background: #ffffff; color: #aa2736; }
  .groomed { background: #ffffff; color: #145b7e; }
  .compact { padding: 1px 2px; border-inline-width: 1px; box-shadow: none; }
  .compact::before, .compact::after { height: 1px; box-shadow: none; }
  .compact .insert { min-width: 0; padding: 0 3px; border: 0; font-size: 12px; font-weight: 800; line-height: 14px; letter-spacing: 0; box-shadow: none; }
  :global(.board .cols) .compact .insert { font-size: 11px; line-height: 13px; }
  :global(.board.focus .cols) .compact .insert { font-size: 12px; line-height: 14px; }
</style>
